import React from 'react';

import { usePageLoadEvent } from '../../utils/analytics/usePageLoadEvent';

import { MlifeActivationContextProvider } from './MlifeActivationContext';
import { MlifeActivationStepper } from './MlifeActivationStepper';

export function MlifeActivationWrapper() {
  usePageLoadEvent('sign up', 'verify account');

  return (
    <MlifeActivationContextProvider>
      <MlifeActivationStepper />
    </MlifeActivationContextProvider>
  );
}
